import React from 'react'
import './index.css';
import { Link } from 'react-router-dom';
import { faCss3, faGithub, faJava, faJs, faNode, faReact } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const HeroSection = () => {
    return (
        <section className="bg-color-dark mb-16">
            <div className="stage-cube-cont mx-img-section hidden md:flex">
                <div className="cubespinner">
                    <div className="face1">
                        
                        <FontAwesomeIcon icon={faNode} color="#DD0031" />
                    </div>
                    <div className="face2">
                        <FontAwesomeIcon icon={faJava} color="#F06529" />
                    </div>
                    <div className="face3">
                        <FontAwesomeIcon icon={faCss3} color="#28A4D9" />
                    </div>
                     <div className="face4">
                        <FontAwesomeIcon icon={faReact} color="#5ED4F4" />
                    </div>
                    <div className="face5">
                        <FontAwesomeIcon icon={faJs} color="#EFD81D" />
                    </div>
                    <div className="face6">
                        <FontAwesomeIcon icon={faGithub} color="#EC4D28" />
                    </div>
                </div>
            </div>
                <div className="px-24 py-12 mx-auto sm:pl-50per sm:pt-100" style={{ paddingBottom: 48 }}>
                    <div className="relative" style={{ maxWidth: 540 }}>
                        <h1
                        className="text-white text-center md:text-65px"
                        style={{ fontSize: "3.5rem" }}
                        >
                        From High-Reliability Systems
                        <span
                            className="text-accent-dark block"
                            style={{ marginTop: "-1rem" }}
                        >
                            to Scalable <span className="text-secondary-dark">Software</span>
                        </span>
                        </h1>
                        <h2 className="text-white text-center text-24px mt-24">
                            Beck Develops is an independent product lab building full-stack systems—from the circuit board to the cloud.
                        </h2>
                        <p
                        className="text-white mt-24 sm:text-18px md:text-18px"
                        style={{ maxWidth: 540 }}
                        >We don't just build apps. We architect end-to-end solutions for complex challenges. Founded by a U.S. Navy systems engineer and full-stack software architect, our work fuses the discipline of high-reliability hardware with the scale of modern, secure SaaS.
                        </p>
                        <div className="flex gap-12 mt-24">
                            <Link to="/projects">
                                <button className="px-24 py-12 primary-color-dark no-border bold br-5 nav-button">
                                    Explore the Products
                                </button>   
                            </Link>
                            <Link to="/about">
                                <button className="px-24 py-12 bg-color-dark text-white no-border bold br-5 nav-button">
                                    About the Architect
                                </button>   
                            </Link>
                        </div>
                        
                    </div>
                </div>
            </section>  
    )
}

export default HeroSection;